/** Ετικέτα trigger για φίλτρο πολλαπλής επιλογής — εμφανίζει τις επιλεγμένες τιμές, όχι «N τύποι». */
export function formatMultiSelectLabel<T extends string>(
  selected: readonly T[],
  getLabel: (value: T) => string,
  emptyLabel: string,
  separator = ', ',
): string {
  if (selected.length === 0) return emptyLabel
  return selected.map(getLabel).join(separator)
}

export function formatMultiSelectLabelFromMap(
  selected: readonly string[],
  labelMap: Record<string, string>,
  emptyLabel: string,
  separator = ', ',
): string {
  return formatMultiSelectLabel(
    selected,
    (key) => labelMap[key] ?? key,
    emptyLabel,
    separator,
  )
}
